import { render, staticRenderFns } from "./PlatformsView.vue?vue&type=template&id=00bee2de&scoped=true&"
import script from "./PlatformsView.vue?vue&type=script&lang=js&"
export * from "./PlatformsView.vue?vue&type=script&lang=js&"
import style0 from "./PlatformsView.vue?vue&type=style&index=0&id=00bee2de&lang=scss&scoped=true&"
import style1 from "./PlatformsView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bee2de",
  null
  
)

export default component.exports